<script lang="ts">
import { getEnv } from '@monogrid/env'
import { usePlatform } from '@monogrid/vue-boost'
import VersionInfo from '@monogrid/vue-boost/core/VersionInfo.vue'
import { computed, defineComponent, inject, ref } from 'vue'

import { setupHead } from '@/composables/useHead'
import { globalInjectionKeys } from '@/main'

import LockScreen from './components/molecules/LockScreen.vue'
import TheLoader from './components/molecules/TheLoader.vue'

export default defineComponent({
  name: 'App',
  components: {
    VersionInfo,
    LockScreen,
    TheLoader
  },
  /**
   * Introduction
   *
   * https://v3.vuejs.org/guide/composition-api-introduction.html#basics-of-composition-api
   *
   * Setup functions
   * https://v3.vuejs.org/guide/composition-api-setup.html
   */

  setup (props, { attrs, slots, emit }) {
    const env = getEnv()
    const preloader = inject(globalInjectionKeys.preloader)

    const platform = usePlatform()

    const sizes = ref({
      width: window.innerWidth,
      height: window.innerHeight
    })

    const checkPlatform = computed(() => {
      return platform.mobile.value || platform.tablet.value
    })

    const checkSize = computed(() => {
      return sizes.value.width > sizes.value.height
    })

    if (preloader) {
      preloader.visible = false
    }

    setupHead({
      siteName: () => 'D&G Beauty Filter',
      siteDescription: () => 'Discover the Italian charm with the magic of Capri'
      // defaultImage: () => `https://${env.SERVICE_TARGET_DOMAIN}${shareImageTODOChangeMe}`
    })

    return {
      env,
      checkPlatform,
      checkSize
    }
  }
})
</script>

<template>
  <div ref="appEl" class="app-container flex flex-auto relative flex-col items-center">
    <LockScreen v-if="checkSize" />
    <TheLoader v-else />

    <RouterView v-slot="{ Component, route }">
      <Transition mode="out-in">
        <!-- be careful with this key: it will transition all pages with different route names (not full paths) -->
        <component :is="Component" v-if="(!route.meta || (route.meta && route.meta.loadingChunk === false)) && Component" :key="route.name" class="page" />
        <!-- when page chunk is not loaded yet or component is not loaded yet, we display this -->
        <div v-else key="loading" class="loading-page-chunk">Loading...</div>
      </Transition>
    </RouterView>

    <!-- version info -->
    <VersionInfo v-if="env.SERVICE_STAGE !== 'production'" />
  </div>
</template>

<style lang="scss">
@import "@/styles/main";
</style>

<style lang="scss" scoped>
.app-container {
  @include svh(100, 'min-height');
}

.loading-page-chunk {
  text-align: center;
}
</style>
